// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"021d9f97","739":"98bcfbf3"}[chunkId] + ".chunk.js";
};